<div class="do-not-modify-banner">
    <div class="icon">
        <span class="material-icons">error</span>
    </div>
    <div class="content">
        <div class="title">
            {{ 'otherTexts.doNotModifyWarning' | translate}}
        </div>
        <div class="sub-text">
            {{ 'otherTexts.doNotModifyInfo' | translate}}
        </div>
        <div class="phones">
            <div>Toyota - 800-331-4331</div>
            <div>Lexus - 800-255-3987</div>
        </div>
    </div>
</div>